var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A453B",
    d: "m14 20 8-7.79L14 4l-1.5 1.5L18 11H2v2h16l-5.5 5.5z"
  })));
};
export { SvgArrowRight as Icon };
export default __webpack_public_path__ + "static/media/9e200f2f1410542d06c6a6bafe860fa2.svg";